import { VideoAccessType, VideoPricing } from "../../../api/tournament/videoService";

const selectableAccessTypes = ["free", "paid", "exclusive_paid"] as const;

export const toDateInputValue = (value?: string) =>
  /^\d{4}-\d{2}-\d{2}/.test(value || "") ? value!.slice(0, 10) : "";

export const toTimeInputValue = (value?: string) => {
  const match = value?.match(/T(\d{2}:\d{2})/);
  return match?.[1] || "";
};

export const buildVideoDateTime = (date: string, time: string) =>
  `${date}T${time}:00.000+00:00`;

export const getInrPrice = (pricing?: VideoPricing) =>
  pricing?.IN?.amount === undefined ? "" : String(pricing.IN.amount);

export const buildVideoPricing = (accessType: VideoAccessType, price: string): VideoPricing | undefined => {
  const amount = Number(price);
  if (accessType !== "exclusive_paid" || !price.trim() || !Number.isFinite(amount) || amount <= 0) {
    return undefined;
  }

  return { IN: { amount, currency: "INR" } };
};

export const normalizeVideoAccessType = (value: unknown): VideoAccessType => {
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : "";
  if (normalized === "inherit" || selectableAccessTypes.includes(normalized as typeof selectableAccessTypes[number])) {
    return normalized as VideoAccessType;
  }

  return "free";
};
